import { COLORS } from '@shared/config/colors/colors';
import { baseShadowStyle } from '@shared/style/base-shadow';
import { Typography } from '@shared/ui/typography/typography';
import { styled } from 'goober';

export const Title = styled(Typography)`
    transition: color 0.3s ease;
`;

export const Wrapper = styled('div')`
    display: flex;
    flex-direction: column;
    padding: 16px 20px;
    gap: 12px;
    border-radius: 12px;
    background-color: ${COLORS.neutral_00};
    cursor: pointer;
    ${baseShadowStyle}

    &:hover ${Title} {
        color: ${COLORS.primary_60};
    }
`;

export const CellsWrapper = styled('div')`
    display: flex;
    gap: 24px;
`;

export const Cell = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: flex-start;
`;
